import {onFind} from "@elements/init-modules-in-scope";
import {on, findAllIn, findIn, trigger,setAttribute, removeAttribute, getAtrribute, addClass, removeClass} from "@elements/dom-utils";


export function init() {
    onFind('.js-conditional-form', function (form) {
        const radioButtons = findAllIn('.js-conditional-form__item input', form);
        console.log(radioButtons);
        radioButtons.forEach(function (btn) {
            on('click', function (){
                const selectedValue = this.value;
                const contents = findAllIn('.js-conditional-form__content', form);
                const contentsInputs = findAllIn('.js-conditional-form__content input', form);
                contents.forEach(function (contentArea) {
                       let contentAreaName = contentArea.dataset.conditionalFormValue;
                       console.log(contentArea.dataset.conditionalFormValue);
                       console.log(selectedValue);
                        if (contentAreaName === selectedValue) {
                            addClass('d-block', contentArea);
                            removeClass('d-none',contentArea);
                        } else {
                            addClass('d-none', contentArea);
                            removeClass('d-block', contentArea);
                        }
                })
                contentsInputs.forEach(function (contentInputs) {
                       contentInputs.checked=false;
                       //trigger('change', contentInputs);
                })
            }, btn)
        })
    });
}
